import { useMediaQuery } from '@mui/system';

export function useIsMobile() {
  return useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
}
